import {createAction} from '@reduxjs/toolkit';
import {
    apiCallPrepareActionBuilder,
    apiErrorPrepareAction,
    apiResponsePrepareAction,
} from 'modules/api/actions';
import {apiEndpoints} from 'modules/api/constants';
import slice from 'modules/applications/slice';

export const {setApps, setSelectedApplication, setTokenStatus, setErrorFlag, resetApps} = slice.actions;

export const applicationsLoadInProgress = createAction('applications/applicationsLoadInProgress');
export const receiveApplications = createAction('applications/receiveApplications', apiResponsePrepareAction);
export const applicationsError = createAction('applications/applicationsError', apiErrorPrepareAction);
export const selectApplication = createAction('applications/selectApplication');

export const getUserApplications = createAction(
    'getUserApplications',
    apiCallPrepareActionBuilder(
        apiEndpoints.APPLICATIONS,
        'get',
        applicationsLoadInProgress,
        receiveApplications,
        applicationsError,
    )
);